import { render, staticRenderFns } from "./BankCardhm.vue?vue&type=template&id=070492d0&scoped=true&"
import script from "./BankCardhm.vue?vue&type=script&lang=js&"
export * from "./BankCardhm.vue?vue&type=script&lang=js&"
import style0 from "./BankCardhm.vue?vue&type=style&index=0&id=070492d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070492d0",
  null
  
)

export default component.exports